import { returnJsonResponse } from "./AuthenticationService";
import { BACKEND_URL } from "./BackendConfig";

export const fetchCoachingConfig = async () => {
    const response = await fetch(`${BACKEND_URL}/coaching-configuration`);
    return await returnJsonResponse(response);
}